import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { getLink } from '../../utils';
import { ImageModalCircleCactus } from '../assets/ImageModalCircleCactus';

export function CreateAccountModal() {
  const { t } = useTranslation('modais');
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.ACCOUNT_NOT_FOUND)
  }

  const handleCreateAccountClick = () => {
    window.location.href = getLink('cadastro');
  }

  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.ACCOUNT_NOT_FOUND)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalCircleCactus />
            </div>
            <p className="modal-title">{t('new_cadu_acesso_01.title')}</p>
            <p className="modal-subtitle">
              {t('new_cadu_acesso_01.description')}
            </p>

            <ul>
              <li>{t('new_cadu_acesso_01.list.item_0')}</li>
              <li>{t('new_cadu_acesso_01.list.item_1')}</li>
              <li>
                <span>
                  {t('new_cadu_acesso_01.list.item_2_0')}
                  <strong>{t('new_cadu_acesso_01.list.item_2_1_bold')}</strong>
                  {t('new_cadu_acesso_01.list.item_2_2')} 
                  <strong>{t('new_cadu_acesso_01.list.item_2_3_bold')}</strong> 
                  {t('new_cadu_acesso_01.list.item_2_4')} 
                </span>
                <a href="https://www.smiles.com.br/acesso-unico">{t('new_cadu_acesso_01.list.item_2_5_anchor')}</a>
              </li>
            </ul>

          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <SmlsButton text={t('new_cadu_acesso_01.button_primary')} color="hyperlink" onClick={handleCreateAccountClick} />
        <SmlsButton className="button" text={t('new_cadu_acesso_01.button_secondary')} onClick={toggleModal} />
      </ModalFooter>
    </SmlsModal>
  );
}
